import { redirect, useLoaderData } from "react-router-dom"
import { formatDate } from "../../functions/formatDate"

type Event = {
    id: number;
    title: string,
    date: string,
    time: string,
    location: string,
    cost: string,
    url_slug: string,
    archived: boolean
}

export async function Loader() {
    
    const response1 = await fetch(`${import.meta.env.VITE_API_URL}/verify`, {
            method: "GET",
            credentials: 'include',    
        })
    
    if(!response1.ok){
        throw redirect('/admin')
    } else {
        const response2 = await fetch(`${import.meta.env.VITE_API_URL}/eventsBE`, {
            credentials: 'include'
        })


        if (response2.status === 401){
            throw redirect("/admin")
        } else if (!response2.ok){
            throw new Response("Failed to fetch events", {status: response2.status})
        }

        const eventData: Event[] = await response2.json()
    
        return eventData
    }
}


export default function Posts() {
    const eventData = useLoaderData() as Event []
    let events = []
    let archivedEvents = []

    for(const item of eventData) {
        if(!item.archived) {
            events.push(item)
        } else {
            archivedEvents.push(item)
        }
    }

    let renderedEvents = events
        .sort((a,b)=>{return Date.parse(a.date) - Date.parse(b.date)})
        .map((item) => {
            return <div className="event-line" key={item.id}>
                <p className="edit-title">{item.title}</p>
                <p className="edit-date">{formatDate(item.date)}</p>
                <a className="edit-link" href={`/admin/new-post/${item.url_slug}`}><p>Edit</p></a>
            </div>
        }) 

    let renderedDeletedEvents = archivedEvents
        .sort((a,b)=>{return Date.parse(a.date) - Date.parse(b.date)})
        .map((item) => {
            return <div className="event-line" key={item.id}>
                <p className="edit-title">{item.title}</p>
                <p className="edit-date">{formatDate(item.date)}</p>
                <a className="edit-link" href={`/admin/new-post/${item.url_slug}`}><p>Edit</p></a>
            </div>
        }) 

    return <>
        <div className="container">
            <h1>Events</h1>
            <div className="event-grid">
                <div className="event-line edit-events" key="home">
                    <p>Title</p>
                    <p>Date</p>
                    <p> </p>
                </div>
                {renderedEvents}
            </div>
            <h2>Archived/Saved Events</h2>
                {renderedDeletedEvents}
        </div>
    </>

}